import React from 'react';
import classNames from 'classnames';
import ResolvePopup from 'components/ResolvePopup';
import { Button } from 'ncoded-component-library';
import DuplicateIcon from 'icons/Duplicate.icon';
import useCopyToClipboard from 'hooks/useCopyToClipboard';
import CheckcircleIcon from 'icons/Checkcircle.icon';
import XcircleIcon from 'icons/Xcircle.icon';

import './VerifiedWithCopy.styles.scss';

type VerifiedWithCopyProps = {
  className?: string;
  copyValue: string;
  copyText: string;
  isVerified: boolean;
  verifiedText: string;
  notVerifiedText: string;
};

const VerifiedWithCopy: React.FC<VerifiedWithCopyProps> = (props) => {
  const {
    children,
    className,
    copyValue,
    copyText,
    isVerified,
    verifiedText,
    notVerifiedText,
  } = props;

  const classes = classNames('verified-with-copy', className);

  const copyToClipboard = useCopyToClipboard();

  return (
    <div className={classes}>
      {children}

      <div className="verified-with-copy__actions">
        <ResolvePopup onHover popupContent={copyText}>
          <Button
            variant="icon"
            icon={DuplicateIcon}
            onClick={(e) => copyToClipboard(e, copyValue)}
          />
        </ResolvePopup>

        <ResolvePopup
          onHover
          popupContent={isVerified ? verifiedText : notVerifiedText}
        >
          {isVerified ? (
            <CheckcircleIcon className="verified" />
          ) : (
            <XcircleIcon className="not-verified" />
          )}
        </ResolvePopup>
      </div>
    </div>
  );
};

export default VerifiedWithCopy;
